module.exports = __webpack_public_path__ + "img/image00002-min.599f0caf.jpeg";